import { type RootState } from '@store/types';

import type { FeatureToggleState } from '../types';

/**
 * Selector for feature toggle state
 * Returns the toggle state for a specific feature key
 */
export const selectFeatureToggleState = (
  state: RootState,
  featureKey: string,
): FeatureToggleState | undefined => {
  return state['featureRolloutToggle/preference']?.features?.[featureKey];
};

